const getTableOptionsByType = (state) => (type) => state[type].tableOptions;
const getSelectedByType = (state) => (type) => state[type].selected;

export default {
  getTableOptionsByType,
  getSelectedByType
};
